module.exports = __webpack_public_path__ + "img/37.19cb0780.webp";